const getTranslations = ({ translations }) => translations.entities;
const getTranslationsIsLoaded = ({ translations }) => translations.isLoaded;

export { getTranslations, getTranslationsIsLoaded };
